import { UserInfoService } from '@/domains/user/services/user-info-service.interface';
import { UserPermissionService } from '@/domains/user/services/user-permission-service.interface';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { computed, ref } from 'vue';
import { useLab } from '../use-lab';
import { ViewType } from '@/domains/base/enums/view-type';
export const useUserInfo = createSharedComposable(() => {
    const userInfoService = injectService(UserInfoService);
    const userPermissionService = injectService(UserPermissionService);
    const { enableLabPatentWordCloud, enableLabWorkspaceLiteTable } = useLab();
    const _userInfo = ref(userInfoService.userInfo);
    userInfoService.subscribeUserInfo((newVal) => {
        _userInfo.value = newVal;
    });
    const userInfo = computed(() => {
        return _userInfo.value;
    });
    const isAdmin = computed(() => {
        return userInfo.value?.admin_console;
    });
    const isFree = computed(() => {
        return userInfo.value?.is_free;
    });
    const isCreatedSpace = computed(() => {
        return userInfo.value.is_created_space;
    });
    const viewTypeList = computed(() => {
        return _.compact([
            ..._userInfo.value.view_type_list,
            enableLabPatentWordCloud.value ? ViewType.WORD_CLOUD : null,
            enableLabWorkspaceLiteTable.value ? ViewType.FAST_TABLE : null,
        ]);
    });
    const updateUserInfo = (userInfo) => {
        userInfoService.updateUserInfo(userInfo);
    };
    const updateAccountPermissionFromAccountInfo = (accountInfo) => {
        /**
         * 从header中获取的用户权限信息
         * upload_flag 为true时表示公司管理后台禁止上传
         * ip_upload_disabled 为true时表示公司管理后台设置IP范围内禁止上传
         */
        userPermissionService.updateAccountPermission({
            enable_upload: !_.get(accountInfo, 'upload_flag', false),
            enable_ip_upload: !_.get(accountInfo, 'ip_upload_disabled', false),
        });
    };
    const updateUserInfoFromHeader = (accountInfo) => {
        userInfoService.updateUserInfoFromHeader(accountInfo);
        updateAccountPermissionFromAccountInfo(accountInfo);
    };
    const updateUserInfoIsCreatedSpace = (isCreatedWorkspace) => {
        userInfoService.updateUserInfoIsCreatedSpace(isCreatedWorkspace);
    };
    return {
        userInfo,
        isAdmin,
        isFree,
        isCreatedSpace,
        viewTypeList,
        updateUserInfo,
        updateUserInfoIsCreatedSpace,
        updateUserInfoFromHeader,
    };
});
